import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";

import { App } from "@common/models";

import { useAppContext } from "./App.context";

type AppSelectionContext = {
  selectedApp: App | undefined;
};

const initial: AppSelectionContext = {
  selectedApp: undefined,
};

const appSelectionContext = createContext<AppSelectionContext>(initial);

export const AppSelectionContextProvider = ({ children }: { children: ReactNode }) => {
  const { loading, app } = useAppContext();
  const [selection, setSelection] = useState<AppSelectionContext>(initial);

  useEffect(() => {
    if (loading) return;

    setSelection((selection) => {
      return {
        ...selection,
        selectedApp: app,
      };
    });
  }, [app, loading]);

  return <appSelectionContext.Provider value={selection}>{children}</appSelectionContext.Provider>;
};

export const useAppSelectionContext = () => {
  return useContext(appSelectionContext);
};
